import React, {memo, useContext} from 'react';
import './QuickEntryCard.less';

import {EntryName} from 'new-components/elements/entry-name/EntryName';
import {EntryDescription} from 'new-components/elements/entry-description/EntryDescription';
import {EntryPrice} from 'new-components/elements/entry-price/EntryPrice';
import {EntryImage} from 'new-components/elements/entry-image/EntryImage.tsx';
import {Badge, BadgeStyles} from 'elements/badge/Badge';
import {TranslationsContext} from 'contexts/translations-context';
import {getSafeTranslation} from 'helpers/localization.helper.ts';
import {applyTags} from 'helpers/format.helper';
import {IconTextButton} from '../../elements/icon-text-button/IconTextButton';
// @ts-ignore
import AllergensIcon from 'new-images/allergens.svg';

interface QuickEntryCardProps {
	name: string,
	description: string,
	price: number,
	image: string,
	isSoldOut: boolean,
	isExpanded: boolean,
	isNotPossibleToOrder: boolean,
	allergens: string,
	onAllergensClick: (allergens: string, e: any) => void,
}

export const QuickEntryCard = memo<QuickEntryCardProps>(({name, description, price, image, isSoldOut, isExpanded, isNotPossibleToOrder, allergens, onAllergensClick}) => {
	const translations = useContext(TranslationsContext);

	return (
		<div className={`quick-entry-card ${isExpanded ? 'quick-entry-card--expanded' : ''}`}>
			<div className="quick-entry-card__info">
				<div className="quick-entry-card__name">
					<EntryName text={name} isExpanded={isExpanded}/>
					{
						isSoldOut && !isExpanded && (
							<div className="quick-entry-card__sold-out">
								<Badge
									text={getSafeTranslation('QuickEntryCard.soldOutLabel', translations)}
									style={BadgeStyles.DISABLED}
								/>
							</div>
						)
					}
					{
						!isNotPossibleToOrder && (
							<div className="quick-entry-card__price-expanded">
								<EntryPrice price={price}/>
							</div>
						)
					}
				</div>
				<div className="quick-entry-card__description">
					<EntryDescription text={applyTags(description?.replace('<a ', '<a target="_blank" '))}
														isExpanded={isExpanded}/>
				</div>
				{
					!isNotPossibleToOrder && (<div className="quick-entry-card__price-quick">
						<EntryPrice price={price}/>
					</div>)
				}
				{
					allergens?.length > 0 && (
						<div className="quick-entry-card__allergens">
							<IconTextButton
								text={getSafeTranslation('EntryAllergens.label', translations)}
								icon={AllergensIcon}
								onClick={(e) => onAllergensClick(allergens, e)}
							/>
						</div>)
				}
			</div>
			{!isExpanded && (
				<div className="quick-entry-card__image">
					<EntryImage src={image}/>
				</div>
			)}
		</div>
	);
});
